exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".table > tbody > tr > td, .table > tfoot > tr > td {\n  vertical-align: middle; }\n\n@media screen and (max-width: 600px) {\n  table#cart tbody td .form-control {\n    width: 20%;\n    display: inline !important; }\n  .actions .btn {\n    width: 36%;\n    margin: 1.5em 0; }\n  .actions .btn-info {\n    float: left; }\n  .actions .btn-danger {\n    float: right; }\n  table#cart thead {\n    display: none; }\n  table#cart tbody td {\n    display: block;\n    padding: .6rem;\n    min-width: 320px; }\n  table#cart tbody tr td:first-child {\n    background: #6999c1;\n    color: #fff; }\n  table#cart tbody td:before {\n    content: attr(data-th);\n    font-weight: bold;\n    display: inline-block;\n    width: 8rem; }\n  table#cart tfoot td {\n    display: block; }\n  table#cart tfoot td .btn {\n    display: block; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/cart/cart.component.scss
// module id = 55
// module chunks = 0 1